import { Capsule as e } from "./Composer.styled.mjs";
import { ComposerField as t } from "./components/ComposerField.mjs";
import { ComposerSend as n } from "./components/ComposerSend.mjs";
import { ComposerAction as r } from "./components/ComposerAction.mjs";
import "react";
import { jsx as i } from "react/jsx-runtime";
var a = ({ tone: t = "default", children: n, ...r }) => /* @__PURE__ */ i(e, {
	$tone: t,
	...r,
	children: n
});
a.Field = t, a.Send = n, a.Action = r;
//#endregion
export { a as Composer };
